import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Painel } from '../../shared/models/painel';
import { PainelService } from '../../shared/services/painel.service';
import { PainelCardComponent } from '../../shared/components/painel-card/painel-card.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { LocalContextService } from '../../shared/services/local-context.service';
import { LocalId } from '../../shared/enums/local.enum';
import { ToastService } from '../../shared/services/toast.service';
import { ToastState as ts } from '../../shared/enums/toast-state.enum';
import { of, Subscription, switchMap, timer } from 'rxjs';
@Component({
  selector: 'app-painel',
  imports: [PainelCardComponent, TegelModule],
  templateUrl: './painel.component.html',
  styleUrl: './painel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PainelComponent implements OnInit, OnDestroy {
  private readonly LOCAL_LAYOUT = new Map<number, string[]>([
    [LocalId.SLA, ['SEGURANÇA', 'FISCAL', 'DIRETOS', 'INDIRETOS']],
    [LocalId.LCB, ['SEGURANÇA', 'PRODUTIVO', 'EXPEDIÇÃO EMBALAGEM']],
  ]);

  public fasesView: { nome: string; itens: Painel[] }[] = [];

  private sub?: Subscription;
  private cache = new Map<number, Painel>();

  constructor(
    private service: PainelService,
    private localContextService: LocalContextService,
    private toast: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const UPDATE_TIME_MS = 10000;

    this.sub = this.localContextService.currentLocalId$
      .pipe(
        switchMap((localId) => {
          if (!localId) {
            this.fasesView = [];
            return of(null);
          }

          const layout = this.LOCAL_LAYOUT.get(localId) || [];

          this.fasesView = layout.map((nome) => ({
            nome,
            itens: [],
          }));

          return timer(0, UPDATE_TIME_MS).pipe(
            switchMap(() => this.service.getAll(+localId)),
          );
        }),
      )
      .subscribe({
        next: (result) => {
          if (result?.content) {
            this.updateView(result.content);
            this.cdr.markForCheck();
          }
        },
        error: (e) => {
          this.toast.showToast(
            ts.error,
            e.error?.[0] || 'Erro ao atualizar o painel.',
          );
        },
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private updateView(itens: Painel[]) {
    const mapa = new Map<string, Painel[]>();

    for (const item of itens) {
      let cached = this.cache.get(item.filaId);

      if (!cached || JSON.stringify(cached) !== JSON.stringify(item)) {
        cached = { ...item };
        this.cache.set(item.filaId, cached);
      }

      if (!mapa.has(cached.nomeExibicaoFase)) {
        mapa.set(cached.nomeExibicaoFase, []);
      }

      mapa.get(cached.nomeExibicaoFase)!.push(cached);
    }

    for (const fase of this.fasesView) {
      fase.itens = mapa.get(fase.nome) || [];
    }
  }
}
